<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Справочники</T>
    </Teleport>  
    
    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-274"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>
    

    <References :loading="loading" :config="$store.getters.config" ref="form" />
  </div>
</template>

<script>
import References from '../../components/settings/references'
import Teleport from 'vue2-teleport'

export default {
  components: {
    Teleport,
    References
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = this.$refs.form.submit()

        await this.$store.dispatch('updateConfig', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>